import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { MdAddAPhoto, MdCameraAlt, MdDelete, MdSave, MdStopCircle } from "react-icons/md";
import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl } from "../../../contexts/ContextProvider";
import { ConfirmDeleteDialog, Loader, ScrollToTop } from "../../../components";

const UbahEntryPermohonan = () => {
  const { user, dispatch } = useContext(AuthContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);

  const [namaPemohon, setNamaPemohon] = useState("");
  const [fotoKtp, setFotoKtp] = useState([]);
  const [fotoKk, setFotoKk] = useState([]);
  const [fotoPenjamin, setFotoPenjamin] = useState([]);
  const [fotoKendaraan, setFotoKendaraan] = useState([]);
  const [fotoStnkBpkb, setFotoStnkBpkb] = useState([]);
  const [fotoLingkungan, setFotoLingkungan] = useState([]);
  const [fotoLainPendukung, setFotoLainPendukung] = useState([]);
  const [newFotoKtp, setNewFotoKtp] = useState([]);
  const [newFotoKk, setNewFotoKk] = useState([]);
  const [newFotoPenjamin, setNewFotoPenjamin] = useState([]);
  const [newFotoKendaraan, setNewFotoKendaraan] = useState([]);
  const [newFotoStnkBpkb, setNewFotoStnkBpkb] = useState([]);
  const [newFotoLingkungan, setNewFotoLingkungan] = useState([]);
  const [newFotoLainPendukung, setNewFotoLainPendukung] = useState([]);
  const [previewKtp, setPreviewKtp] = useState([]);
  const [previewKk, setPreviewKk] = useState([]);
  const [previewPenjamin, setPreviewPenjamin] = useState([]);
  const [previewKendaraan, setPreviewKendaraan] = useState([]);
  const [previewStnkBpkb, setPreviewStnkBpkb] = useState([]);
  const [previewLingkungan, setPreviewLingkungan] = useState([]);
  const [previewLainPendukung, setPreviewLainPendukung] = useState([]);
  const [activeFotoKey, setActiveFotoKey] = useState("");
  const [cameraActive, setCameraActive] = useState(false);
  const [cameraError, setCameraError] = useState("");
  const [currentLocation, setCurrentLocation] = useState(null);
  const [status, setStatus] = useState("BELUM");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [deleteFotoTarget, setDeleteFotoTarget] = useState(null);
  const tipeUser = (user?.tipeUser || "").trim().toUpperCase();
  const isSurveyor = ["SUR", "SURVEYOR"].includes(tipeUser);
  const isEditLocked =
    isSurveyor && ["ACC", "REJECT"].includes(status.toUpperCase());

  useEffect(() => {
    loadData();
  }, [id]);

  useEffect(() => {
    return () => {
      stopCamera(false);
    };
  }, []);

  const fotoSections = [
    { key: "fotoKtp", title: "Foto KTP", oldImages: fotoKtp, setOldImages: setFotoKtp, newFiles: newFotoKtp, previews: previewKtp, setNewFiles: setNewFotoKtp, setPreviews: setPreviewKtp },
    { key: "fotoKk", title: "KK", oldImages: fotoKk, setOldImages: setFotoKk, newFiles: newFotoKk, previews: previewKk, setNewFiles: setNewFotoKk, setPreviews: setPreviewKk },
    { key: "fotoPenjamin", title: "Penjamin", oldImages: fotoPenjamin, setOldImages: setFotoPenjamin, newFiles: newFotoPenjamin, previews: previewPenjamin, setNewFiles: setNewFotoPenjamin, setPreviews: setPreviewPenjamin },
    { key: "fotoKendaraan", title: "Kendaraan Depan/Belakang", oldImages: fotoKendaraan, setOldImages: setFotoKendaraan, newFiles: newFotoKendaraan, previews: previewKendaraan, setNewFiles: setNewFotoKendaraan, setPreviews: setPreviewKendaraan },
    { key: "fotoStnkBpkb", title: "STNK & BPKB", oldImages: fotoStnkBpkb, setOldImages: setFotoStnkBpkb, newFiles: newFotoStnkBpkb, previews: previewStnkBpkb, setNewFiles: setNewFotoStnkBpkb, setPreviews: setPreviewStnkBpkb },
    { key: "fotoLingkungan", title: "Lingkungan", oldImages: fotoLingkungan, setOldImages: setFotoLingkungan, newFiles: newFotoLingkungan, previews: previewLingkungan, setNewFiles: setNewFotoLingkungan, setPreviews: setPreviewLingkungan },
    { key: "fotoLainPendukung", title: "Lain2 Pendukung", oldImages: fotoLainPendukung, setOldImages: setFotoLainPendukung, newFiles: newFotoLainPendukung, previews: previewLainPendukung, setNewFiles: setNewFotoLainPendukung, setPreviews: setPreviewLainPendukung },
  ];

  const handleAuthError = (err) => {
    if (err.response?.status === 401) {
      dispatch({ type: "LOGOUT" });
      navigate("/");
    }
  };

  const loadData = async () => {
    setLoading(true);
    try {
      const payload = {
        id: user._id,
        token: user.token,
      };
      const permohonanRes = await axios.post(`${tempUrl}/permohonans/${id}`, payload);
      const pickedEntryPermohonan = permohonanRes.data;

      setNamaPemohon(pickedEntryPermohonan.namaPemohon || "");
      setStatus(pickedEntryPermohonan.status || "BELUM");
      setFotoKtp(pickedEntryPermohonan.fotoKtp || []);
      setFotoKk(pickedEntryPermohonan.fotoKk || []);
      setFotoPenjamin(pickedEntryPermohonan.fotoPenjamin || []);
      setFotoKendaraan(pickedEntryPermohonan.fotoKendaraan || []);
      setFotoStnkBpkb(pickedEntryPermohonan.fotoStnkBpkb || []);
      setFotoLingkungan(pickedEntryPermohonan.fotoLingkungan || []);
      setFotoLainPendukung(pickedEntryPermohonan.fotoLainPendukung || []);
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal mengambil data permohonan.");
    }
    setLoading(false);
  };

  const getCurrentLocation = () => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error("Browser tidak mendukung akses lokasi."));
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            accuracy: position.coords.accuracy,
            capturedAt: new Date().toISOString(),
          });
        },
        () => reject(new Error("Lokasi/GPS wajib aktif sebelum membuka kamera.")),
        {
          enableHighAccuracy: true,
          timeout: 15000,
          maximumAge: 0,
        },
      );
    });
  };

  const waitForVideoElement = () => {
    return new Promise((resolve) => {
      const findVideo = () => {
        if (videoRef.current) {
          resolve(videoRef.current);
          return;
        }

        setTimeout(findVideo, 30);
      };

      findVideo();
    });
  };

  const playCameraStream = async (stream) => {
    const video = await waitForVideoElement();
    video.srcObject = stream;

    try {
      await video.play();
    } catch (err) {
      const isInterruptedPlay =
        err.name === "AbortError" ||
        err.message?.includes("interrupted by a new load request");

      if (!isInterruptedPlay) {
        throw err;
      }

      setTimeout(() => {
        if (video.srcObject === stream) {
          video.play().catch(() => {});
        }
      }, 120);
    }
  };

  const startCamera = async (fotoKey) => {
    if (isEditLocked) {
      setError(
        `Entry Permohonan berstatus ${status} tidak dapat diubah oleh Surveyor.`,
      );
      return;
    }

    try {
      stopCamera(false);
      setCameraError("");
      setActiveFotoKey(fotoKey);

      const location = await getCurrentLocation();
      setCurrentLocation(location);

      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        setCameraError("Browser tidak mendukung akses kamera.");
        return;
      }

      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: { ideal: "environment" },
        },
        audio: false,
      });

      streamRef.current = stream;
      await playCameraStream(stream);

      setCameraActive(true);
    } catch (err) {
      setCameraError(err.message || "Kamera tidak bisa dibuka. Pastikan izin kamera dan lokasi diberikan.");
      console.log(err);
    }
  };

  const stopCamera = (updateState = true) => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
    }

    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }

    if (updateState) {
      setCameraActive(false);
      setActiveFotoKey("");
      setCurrentLocation(null);
    }
  };

  const capturePhoto = async (section) => {
    if (!videoRef.current || !canvasRef.current) {
      return;
    }

    let latestLocation = currentLocation;

    try {
      latestLocation = await getCurrentLocation();
      setCurrentLocation(latestLocation);
    } catch (err) {
      setCameraError("Lokasi/GPS wajib aktif sebelum mengambil foto.");
      return;
    }

    const video = videoRef.current;
    const canvas = canvasRef.current;
    const width = video.videoWidth;
    const height = video.videoHeight;

    if (!width || !height) {
      setCameraError("Kamera belum siap. Coba ambil foto sekali lagi.");
      return;
    }

    canvas.width = width;
    canvas.height = height;
    canvas.getContext("2d").drawImage(video, 0, 0, width, height);

    canvas.toBlob(
      (blob) => {
        if (!blob) {
          setCameraError("Foto gagal diambil. Coba ulangi.");
          return;
        }

        const fileName = `permohonan-${section.key}-${Date.now()}.jpg`;
        const capturedFile = new File([blob], fileName, {
          type: "image/jpeg",
          lastModified: Date.now(),
        });

        section.setNewFiles((prevFiles) => [
          ...prevFiles,
          {
            file: capturedFile,
            latitude: latestLocation.latitude,
            longitude: latestLocation.longitude,
            accuracy: latestLocation.accuracy,
            capturedAt: latestLocation.capturedAt,
          },
        ]);
        section.setPreviews((prevPreviews) => [...prevPreviews, URL.createObjectURL(capturedFile)]);
        setCameraError("");
      },
      "image/jpeg",
      0.9,
    );
  };

  const uploadFotoGroup = async (files) => {
    const uploadedImageUrls = await Promise.all(
      files.map(async (selectedPhoto) => {
        const selectedFile = selectedPhoto.file || selectedPhoto;
        const storageRef = firebase.storage().ref();
        const fileRef = storageRef.child(
          `${Date.now()}-${Math.floor(Math.random() * 1000 + 1)}-${selectedFile.name}`,
        );
        const snapshot = await fileRef.put(selectedFile);
        const url = await snapshot.ref.getDownloadURL();

        return {
          url,
          latitude: selectedPhoto.latitude,
          longitude: selectedPhoto.longitude,
          accuracy: selectedPhoto.accuracy,
          capturedAt: selectedPhoto.capturedAt,
        };
      }),
    );

    return uploadedImageUrls;
  };

  const hapusFoto = (section, img) => {
    setDeleteFotoTarget({
      type: "old",
      section,
      img,
    });
  };

  const hapusFotoBaru = (section, index) => {
    setDeleteFotoTarget({
      type: "new",
      section,
      index,
    });
  };

  const confirmHapusFoto = () => {
    if (!deleteFotoTarget) {
      return;
    }

    if (deleteFotoTarget.type === "old") {
      const section = deleteFotoTarget.section;
      const img = deleteFotoTarget.img;

      section.setOldImages(section.oldImages.filter((item) => item !== img));

      try {
        const image = firebase.storage().refFromURL(img.url || img);
        image.delete().catch(() => {});
      } catch (err) {
        console.log(err);
      }
    }

    if (deleteFotoTarget.type === "new") {
      const section = deleteFotoTarget.section;
      const index = deleteFotoTarget.index;

      section.setNewFiles(section.newFiles.filter((item, i) => i !== index));
      section.setPreviews(section.previews.filter((item, i) => i !== index));
    }

    setDeleteFotoTarget(null);
  };

  const getPhotoUrl = (photo) => {
    return typeof photo === "string" ? photo : photo?.url;
  };

  const updateEntryPermohonan = async (event) => {
    event.preventDefault();

    if (isEditLocked) {
      setError(
        `Entry Permohonan berstatus ${status} tidak dapat diubah oleh Surveyor.`,
      );
      return;
    }

    if (!namaPemohon) {
      setError("Nama pemohon wajib diisi.");
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${tempUrl}/updatePermohonan/${id}`, {
        namaPemohon,
        id: user._id,
        token: user.token,
      });

      const fotoKtpUploaded = await uploadFotoGroup(newFotoKtp);
      const fotoKkUploaded = await uploadFotoGroup(newFotoKk);
      const fotoPenjaminUploaded = await uploadFotoGroup(newFotoPenjamin);
      const fotoKendaraanUploaded = await uploadFotoGroup(newFotoKendaraan);
      const fotoStnkBpkbUploaded = await uploadFotoGroup(newFotoStnkBpkb);
      const fotoLingkunganUploaded = await uploadFotoGroup(newFotoLingkungan);
      const fotoLainPendukungUploaded = await uploadFotoGroup(newFotoLainPendukung);

      await axios.post(`${tempUrl}/uploadFotoPermohonan/${id}`, {
        fotoKtp: [...fotoKtp, ...fotoKtpUploaded],
        fotoKk: [...fotoKk, ...fotoKkUploaded],
        fotoPenjamin: [...fotoPenjamin, ...fotoPenjaminUploaded],
        fotoKendaraan: [...fotoKendaraan, ...fotoKendaraanUploaded],
        fotoStnkBpkb: [...fotoStnkBpkb, ...fotoStnkBpkbUploaded],
        fotoLingkungan: [...fotoLingkungan, ...fotoLingkunganUploaded],
        fotoLainPendukung: [...fotoLainPendukung, ...fotoLainPendukungUploaded],
        id: user._id,
        token: user.token,
      });

      navigate(`/permohonan/${id}`);
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal mengubah permohonan.");
      setLoading(false);
    }
  };

  const renderFotoInput = (section) => {
    return (
      <section className="section-panel mt-3" key={section.key}>
        <h2 className="h6 fw-bold mb-3">{section.title}</h2>
        {cameraError && activeFotoKey === section.key && <Alert variant="warning">{cameraError}</Alert>}
        <div className="camera-box">
          {activeFotoKey === section.key && (
            <>
              <video
                ref={videoRef}
                playsInline
                muted
                className="camera-preview"
                style={{ display: cameraActive ? "block" : "none" }}
              />
              <canvas ref={canvasRef} style={{ display: "none" }} />
            </>
          )}
        </div>
        <div className="form-actions mb-3">
          <Button className="btn-icon" type="button" onClick={() => startCamera(section.key)} disabled={cameraActive && activeFotoKey === section.key}>
            <MdCameraAlt /> Buka Kamera
          </Button>
          <Button className="btn-icon" type="button" variant="success" onClick={() => capturePhoto(section)} disabled={!cameraActive || activeFotoKey !== section.key}>
            <MdAddAPhoto /> Ambil Foto
          </Button>
          <Button className="btn-icon" type="button" variant="outline-secondary" onClick={stopCamera} disabled={!cameraActive || activeFotoKey !== section.key}>
            <MdStopCircle /> Tutup Kamera
          </Button>
        </div>
        {section.previews.length > 0 && <div className="detail-label mb-2">Foto Baru</div>}
        <div className="photo-grid">
          {section.previews.map((img, i) => (
            <div className="photo-card old-photo-card" key={`${section.key}-new-${i}`}>
              <button type="button">
                <img src={img} alt={`${section.title} baru ${i + 1}`} />
                <span>No. {i + 1}</span>
              </button>
              <Button className="photo-delete-btn" size="sm" variant="outline-danger" type="button" onClick={() => hapusFotoBaru(section, i)}>
                <MdDelete /> Hapus
              </Button>
            </div>
          ))}
        </div>
        {section.oldImages.length > 0 && <div className="detail-label mt-3 mb-2">Foto Lama</div>}
        <div className="photo-grid">
          {section.oldImages.map((img, i) => (
            <div className="photo-card old-photo-card" key={`${section.key}-old-${i}`}>
              <button type="button" onClick={() => window.open(getPhotoUrl(img), "_blank", "noopener,noreferrer")}>
                <img src={getPhotoUrl(img)} alt={`${section.title} lama ${i + 1}`} />
                <span>No. {i + 1}</span>
              </button>
              <Button className="photo-delete-btn" size="sm" variant="outline-danger" type="button" onClick={() => hapusFoto(section, img)}>
                <MdDelete /> Hapus
              </Button>
            </div>
          ))}
        </div>
      </section>
    );
  };

  if (loading) {
    return <Loader />;
  }

  if (isEditLocked) {
    return (
      <div>
        <ScrollToTop />
        <div className="page-header">
          <div>
            <div className="page-kicker">Survey</div>
            <h1 className="page-title">Ubah Entry Permohonan</h1>
          </div>
        </div>
        <section className="section-panel">
          <Alert variant="warning">
            Entry Permohonan berstatus {status} tidak dapat diubah oleh
            Surveyor.
          </Alert>
          <Button
            className="btn-back"
            type="button"
            variant="outline-secondary"
            onClick={() => navigate(`/permohonan/${id}`)}
          >
            {"< Kembali"}
          </Button>
        </section>
      </div>
    );
  }

  return (
    <div>
      <ScrollToTop />
      <div className="page-header">
        <div>
          <div className="page-kicker">Survey</div>
          <h1 className="page-title">Ubah Entry Permohonan</h1>
        </div>
      </div>
      <section className="section-panel">
        {error && <Alert variant="warning">{error}</Alert>}
        <Form onSubmit={updateEntryPermohonan}>
          <Row>
            <Col lg={6} md={8}>
              <Form.Group className="mb-3">
                <Form.Label>Nama Pemohon</Form.Label>
                <Form.Control
                  value={namaPemohon}
                  onChange={(e) => setNamaPemohon(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          {fotoSections.map((section) => renderFotoInput(section))}
          <div className="form-actions mt-3">
            <Button className="btn-back" type="button" variant="outline-secondary" onClick={() => navigate(`/permohonan/${id}`)}>
              {"< Kembali"}
            </Button>
            <Button className="btn-icon" type="submit">
              <MdSave /> Simpan
            </Button>
          </div>
        </Form>
      </section>
      <ConfirmDeleteDialog
        show={Boolean(deleteFotoTarget)}
        message="Yakin ingin menghapus foto ini?"
        onCancel={() => setDeleteFotoTarget(null)}
        onConfirm={confirmHapusFoto}
      />
    </div>
  );
};

export default UbahEntryPermohonan;
